import { Select, Checkbox } from "@vitalsource/vstui";
import React, { ChangeEvent, useState } from "react";
import styled from "styled-components";
import { TTSProps } from "./withTTS";
import { cloud } from "@vitalsource/vstui/colors";
import Slider from "./Slider";
import { throttle } from "throttle-debounce";
import {
  FormattedMessage,
  injectIntl,
  WrappedComponentProps,
} from "react-intl";
import PopoverHeader from "../../common/PopoverHeader";

const Styled = {
  Note: styled.div`
    font-style: italic;
    font-size: 1.2rem;
    margin-top: -12px;
    margin-bottom: -6px;
  `,
  CheckboxContainer: styled.div`
    margin: 24px 0;
  `,
  Header: styled.h3`
    background: ${cloud.getShade(2)};
    color: ${cloud.getShade(9)};
    padding: 6px 17px;
    border-bottom: 1px solid ${cloud.getShade(3)};
    font-size: 1.5rem;
    font-weight: 500;
  `,
  InnerContent: styled.div`
    padding: 18px 24px 0 24px;
  `,
  SliderContainer: styled.div`
    padding-bottom: 16px;
  `,
};

function SettingsContent(
  props: WrappedComponentProps &
    Pick<
      TTSProps,
      | "voices"
      | "altEnabled"
      | "currentVoice"
      | "currentRate"
      | "enableAltText"
      | "disableAltText"
      | "setVoice"
      | "changeRate"
    >
) {
  const [currentSpeed, setSpeed] = useState(props.currentRate);

  function updateVoice(e: ChangeEvent<HTMLSelectElement>) {
    const index = parseInt(e.currentTarget.value, 10);
    props.setVoice(index);
  }

  function toggleAltText() {
    if (props.altEnabled) {
      props.disableAltText();
    } else {
      props.enableAltText();
    }
  }

  const throttledRateChange = throttle(300, (val: number) => {
    props.changeRate(val);
  });

  function updateSpeedValues(speed: number) {
    // We are tracking speed separately from jigsaw's speed to keep the slider snappy
    setSpeed(speed);
    throttledRateChange(speed);
  }

  return (
    <div>
      <PopoverHeader>
        <FormattedMessage id="tts.readAloudSettings" />
      </PopoverHeader>
      <Styled.InnerContent>
        <Styled.SliderContainer>
          <Slider onChange={updateSpeedValues} value={currentSpeed} />
        </Styled.SliderContainer>
        <Select
          label={props.intl.formatMessage({ id: "tts.changeVoice" })}
          onChange={updateVoice}
          value={props.currentVoice}
          fullWidth
        >
          {props.voices.map((voice, index) => (
            <option key={voice.name} value={index}>
              {voice.name} ({voice.lang})
            </option>
          ))}
        </Select>
        <Styled.Note>
          <FormattedMessage id="tts.voiceChangeNotLangChange" />
        </Styled.Note>
        <Styled.CheckboxContainer>
          <Checkbox
            label={props.intl.formatMessage({ id: "tts.readAltText" })}
            onChange={toggleAltText}
            checked={props.altEnabled}
          />
        </Styled.CheckboxContainer>
      </Styled.InnerContent>
    </div>
  );
}

export default injectIntl(SettingsContent);
